var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm._l(_vm.value.lineItems, function (lineItem, index) {
    return _c('v-row', {
      key: 'li' + index,
      attrs: {
        "dense": ""
      }
    }, [_c('v-col', {
      attrs: {
        "cols": "10",
        "md": "6"
      }
    }, [_vm.showProducts && _vm.canReadProduct && !_vm.readonly ? _c('v-combobox', {
      attrs: {
        "label": _vm.$t('objects.invoiceLine.title') + ' *',
        "outlined": "",
        "hide-details": "",
        "dense": "",
        "value": lineItem.title,
        "readonly": _vm.readonly,
        "loading": lineItem.isLoading,
        "cache-items": "",
        "items": _vm.products,
        "item-text": "title",
        "return-object": "",
        "rules": _vm.rules(_vm.RulesEnum.REQUIRED_RULE),
        "search-input": lineItem.search
      },
      on: {
        "input": function input($e) {
          return _vm.onProductInput(lineItem, $e);
        },
        "update:search-input": function updateSearchInput($e) {
          return _vm.debouncedProductSearch($e, lineItem);
        }
      },
      scopedSlots: _vm._u([{
        key: "prepend",
        fn: function fn() {
          return [!_vm.readonly && _vm.showRemove ? _c('tooltip', {
            attrs: {
              "text": _vm.$t('remove')
            }
          }, [_c('v-btn', {
            attrs: {
              "icon": "",
              "x-small": "",
              "readonly": _vm.readonly
            },
            on: {
              "click": function click($event) {
                return _vm.removeInvoiceLine(index);
              }
            }
          }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1) : _vm._e()];
        },
        proxy: true
      }, {
        key: "append-outer",
        fn: function fn() {
          return [lineItem.isLoading ? _c('v-progress-circular', {
            attrs: {
              "size": 10,
              "indeterminate": "",
              "color": "success"
            }
          }) : _vm._e()];
        },
        proxy: true
      }, {
        key: "no-data",
        fn: function fn() {
          return [_c('v-list-item', [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(" " + _vm._s(_vm.$t("repairEstimate.LineItemsForm.noResults", {
            search: lineItem.search
          })) + " "), _c('span', {
            domProps: {
              "innerHTML": _vm._s(_vm.$t('repairEstimate.LineItemsForm.new'))
            }
          })])], 1)], 1)];
        },
        proxy: true
      }, {
        key: "item",
        fn: function fn(_ref) {
          var item = _ref.item;
          return [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(item.title))]), _c('v-list-item-subtitle', [_vm._v(_vm._s(item.description))])], 1)];
        }
      }], null, true)
    }) : _c('v-text-field', {
      attrs: {
        "label": _vm.$t('objects.invoiceLine.title') + ' *',
        "outlined": "",
        "hide-details": "",
        "dense": "",
        "rules": _vm.rules(_vm.RulesEnum.REQUIRED_RULE),
        "readonly": _vm.readonly
      },
      scopedSlots: _vm._u([{
        key: "prepend",
        fn: function fn() {
          return [!_vm.readonly && _vm.showRemove ? _c('tooltip', {
            attrs: {
              "text": _vm.$t('remove')
            }
          }, [_c('v-btn', {
            staticClass: "mt-2 pa-2",
            attrs: {
              "icon": "",
              "x-small": "",
              "readonly": _vm.readonly
            },
            on: {
              "click": function click($event) {
                return _vm.removeInvoiceLine(index);
              }
            }
          }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1) : _vm._e()];
        },
        proxy: true
      }], null, true),
      model: {
        value: lineItem.title,
        callback: function callback($$v) {
          _vm.$set(lineItem, "title", $$v);
        },
        expression: "lineItem.title"
      }
    })], 1), !_vm.readonly && _vm.showRemove ? _c('v-col', {
      staticClass: "d-flex d-sm-none",
      attrs: {
        "cols": "2"
      }
    }, [_c('tooltip', {
      attrs: {
        "text": _vm.$t('remove')
      }
    }, [_c('v-btn', {
      staticClass: "pa-6",
      attrs: {
        "icon": "",
        "small": "",
        "readonly": _vm.readonly
      },
      on: {
        "click": function click($event) {
          return _vm.removeInvoiceLine(index);
        }
      }
    }, [_c('v-icon', [_vm._v("mdi-delete")])], 1)], 1)], 1) : _vm._e(), _vm.showQuantity ? _c('v-col', {
      attrs: {
        "cols": _vm.cols,
        "md": _vm.md
      }
    }, [_c('v-text-field', {
      staticClass: "text-right",
      attrs: {
        "label": _vm.$t('objects.invoiceLine.quantity') + ' *',
        "outlined": "",
        "hide-details": "",
        "dense": "",
        "rules": _vm.rules(_vm.RulesEnum.REQUIRED_RULE),
        "readonly": _vm.readonly
      },
      model: {
        value: lineItem.quantity,
        callback: function callback($$v) {
          _vm.$set(lineItem, "quantity", _vm._n($$v));
        },
        expression: "lineItem.quantity"
      }
    })], 1) : _vm._e(), _vm.showTax ? _c('v-col', {
      attrs: {
        "cols": _vm.cols,
        "md": _vm.md
      }
    }, [_vm.taxRates ? _c('v-autocomplete', {
      staticClass: "text-right",
      attrs: {
        "label": _vm.$t('objects.invoiceLine.taxRate') + ' *',
        "outlined": "",
        "hide-details": "",
        "dense": "",
        "type": "number",
        "suffix": "%",
        "rules": _vm.rules(_vm.RulesEnum.REQUIRED_RULE),
        "readonly": _vm.readonly,
        "items": _vm.taxRates
      },
      model: {
        value: lineItem.taxRate,
        callback: function callback($$v) {
          _vm.$set(lineItem, "taxRate", _vm._n($$v));
        },
        expression: "lineItem.taxRate"
      }
    }) : _c('v-text-field', {
      staticClass: "text-right",
      attrs: {
        "label": _vm.$t('objects.invoiceLine.taxRate') + ' *',
        "outlined": "",
        "hide-details": "",
        "dense": "",
        "step": 1,
        "min": 0,
        "max": 100,
        "type": "number",
        "suffix": "%",
        "rules": _vm.rules(_vm.RulesEnum.REQUIRED_RULE),
        "readonly": _vm.readonly
      },
      model: {
        value: lineItem.taxRate,
        callback: function callback($$v) {
          _vm.$set(lineItem, "taxRate", _vm._n($$v));
        },
        expression: "lineItem.taxRate"
      }
    })], 1) : _vm._e(), _c('v-col', {
      attrs: {
        "cols": _vm.cols,
        "md": _vm.md
      }
    }, [_c('v-text-field', {
      staticClass: "text-right",
      attrs: {
        "label": _vm.$t('objects.invoiceLine.amount') + ' *',
        "outlined": "",
        "hide-details": "",
        "dense": "",
        "rules": _vm.rules(_vm.RulesEnum.REQUIRED_RULE),
        "readonly": _vm.readonly
      },
      model: {
        value: lineItem.amount,
        callback: function callback($$v) {
          _vm.$set(lineItem, "amount", _vm._n($$v));
        },
        expression: "lineItem.amount"
      }
    })], 1)], 1);
  }), !_vm.readonly && _vm.showAdd ? _c('v-row', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-col', [_c('v-btn', {
    attrs: {
      "small": "",
      "text": "",
      "color": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.addInvoiceLine();
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-plus")]), _vm._v(" " + _vm._s(_vm.$t("invoice.addPosition")) + " ")], 1)], 1)], 1) : _vm._e(), _c('v-divider', {
    staticClass: "mt-6"
  }), _c('v-row', {
    staticClass: "pt-2"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-simple-table', {
    staticStyle: {
      "background-color": "transparent"
    }
  }, [_c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }), _c('td', {
    attrs: {
      "colspan": "1"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("objects.invoice.subTotal")) + " ")]), _c('td', {
    staticClass: "text-end",
    attrs: {
      "colspan": "1"
    }
  }, [_c('strong', [_vm._v(" " + _vm._s(_vm.formatCurrency(_vm.value.totalNet, _vm.value.currency)) + " ")])])]), _vm._l(_vm.value.taxRates, function (taxRate) {
    return _c('tr', {
      key: 'taxRate' + taxRate
    }, [_c('td', {
      attrs: {
        "colspan": "4"
      }
    }), _c('td', {
      staticStyle: {
        "min-width": "150px"
      },
      attrs: {
        "colspan": "1"
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.$t("objects.invoiceLine.taxRate")) + " " + _vm._s(taxRate) + " "), _c('span', [_vm._v("%")])])]), _c('td', {
      staticClass: "text-end",
      attrs: {
        "colspan": "1"
      }
    }, [_vm._v(" " + _vm._s(_vm.formatCurrency(_vm.value.calcItemsPerTaxRate(taxRate), _vm.value.currency)) + " ")])]);
  }), _vm.showTax ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }), _c('td', {
    attrs: {
      "colspan": "1"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("objects.invoice.total")) + " ")]), _c('td', {
    staticClass: "text-end",
    attrs: {
      "colspan": "1"
    }
  }, [_c('strong', [_vm._v(" " + _vm._s(_vm.formatCurrency(_vm.value.totalGross, _vm.value.currency)) + " ")])])]) : _vm._e()], 2)], 1)], 1)], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }